import type { Address } from "@silo/types";
import { match } from "ts-pattern";

export function formatAddress(
  address: Address,
  style: AddressStyle = "long"
): string {
  const end = match(style)
    .with("short", () => 4)
    .with("long", () => 6)
    .exhaustive();

  return `${address.slice(0, end)}...${address.slice(-4)}`;
}

type AddressStyle = "short" | "long";
